/*
 * @format
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Icons, Button, HelpTip } from 'sarsaparilla';
import { get } from 'lodash';
import { LOTTERY_TYPES, DATE_FORMAT, RES_ID_DELIMITER, DATE_TIME_FORMAT, DATE_TITLE_FORMAT } from '../utils/constants';

export default class LotteryWidget extends Component {
    static propTypes = {
        lotteries:  PropTypes.arrayOf(PropTypes.object),
        permit: PropTypes.object,
        enterLottery: PropTypes.func,
        isDisabledButton: PropTypes.bool,
        isLoadingButton: PropTypes.bool,
        isOldLotteryFormat: PropTypes.bool,
        isFutureLottery: PropTypes.bool,
        futureLotteryTitle: PropTypes.string,
    }

    static defaultProps = {
        permit: {},
        lotteries: [],
        enterLottery: () => {},
        isDisabledButton: false,
        isLoadingButton: false,
        isOldLotteryFormat: false,
    }

    renderStatusBadge(isInFuture) {
        if (isInFuture) {
            return (<span className="rec-badge-coming-soon">COMING SOON...</span>)
        }
        return <span className="rec-badge-open">OPEN NOW!</span>
    }

    render() {
        const {
            lotteries = [],
            permit,
            enterLottery,
            isDisabledButton,
            isLoadingButton,
            isOldLotteryFormat,
            desktopDisabled,
            futureLotteryTitle,
            isFutureLottery,
        } = this.props;
        const currentDate = moment();
        const timeZone = permit.time_zone === '' ? "America/Los_Angeles": permit.time_zone;
        const lotteriesToRender = lotteries.map(({ lottery, type: lotteryType, daily_lottery_target_date: targetDate }) => {
            const { id: lotteryId, display_at, open_at, close_at, announced_at, inventory_info } = lottery;
            const displayTime = isOldLotteryFormat ? moment(display_at).tz(permit.time_zone) : moment.unix(display_at.seconds).tz(timeZone)
            const openTime = isOldLotteryFormat ? moment(open_at).tz(permit.time_zone) : moment.unix(open_at.seconds).tz(timeZone)
            const closeTime = isOldLotteryFormat ? moment(close_at).tz(permit.time_zone) : moment.unix(close_at.seconds).tz(timeZone);
            const announcedTime = isOldLotteryFormat ? moment(announced_at).tz(permit.time_zone) : moment.unix(announced_at.seconds).tz(timeZone)
            const lotteryRangeStart = isOldLotteryFormat ? moment(get(inventory_info, 'dates.start')).tz(permit.time_zone) : moment.unix(get(inventory_info, 'dates.start.seconds')).utc();
            const lotteryRangeEnd = isOldLotteryFormat ? moment(get(inventory_info, 'dates.end')).tz(permit.time_zone) : moment.unix(get(inventory_info, 'dates.end.seconds')).utc();
            const dailyTripDate = moment(targetDate);
            
            if (!displayTime?.isValid() || !openTime?.isValid() || !closeTime?.isValid() || !lotteryRangeStart?.isValid() || !lotteryRangeEnd?.isValid() || !announcedTime?.isValid()) {
                return null;
            }
            let daysLeft = closeTime.diff(currentDate, 'days');
            let daysLeftLabel;
            switch (daysLeft) {
                case 0:
                 daysLeftLabel = "day";
                 daysLeft = "less than 1";
                 break;
                case 1:
                  daysLeftLabel = "day";
                  break;
                default:
                  daysLeftLabel = "days";
                break;
            }

            const isDailyLottery = isOldLotteryFormat ? !!lottery.is_daily : lotteryType === LOTTERY_TYPES.Daily;
            const entryDates = lotteryRangeStart.isSame(lotteryRangeEnd) ? lotteryRangeStart.format(DATE_FORMAT) :
                `${lotteryRangeStart.format(DATE_FORMAT)} - ${lotteryRangeEnd.format(DATE_FORMAT)}`;
            const isInFuture = currentDate.isBefore(openTime);

            return (
                <div className="rec-lottery-widget-body" key={lotteryId}>
                    <div className="rec-form-item-wrapper-full">
                        <div className="rec-badge-container">
                            {this.renderStatusBadge(isInFuture)}
                        </div>
                        <div className="rec-badge-title">
                            {get(lottery, 'name', `${permit.name} ${isDailyLottery ? 'Daily ' : ''}Lottery`)}
                        </div>
                        {isInFuture && (
                            <div className="rec-badge-title">
                                Opens {openTime.format(DATE_TITLE_FORMAT)}
                            </div>
                        )}
                        <div className="rec-form-item-wrap-full">
                            <div className="rec-data-container">
                                <label htmlFor="rec-lottery-dates">
                                    <b>Trip Dates</b>
                                    <HelpTip
                                        tipForDescriptor="This lottery allows for applications within these dates"
                                        maxWidth={130}
                                        content="This lottery allows for applications within these dates" />
                                </label>
                                <div className="rec-lottery-dates">
                                    {isDailyLottery && dailyTripDate.isValid() ? dailyTripDate.format(DATE_FORMAT) : entryDates}
                                </div>
                            </div>
                            <div className="rec-data-container">
                                {!isInFuture && (
                                    <>
                                        <label htmlFor="rec-lottery-dates"><b>Application Deadline </b> </label>
                                        <div className="rec-lottery-dates">
                                            {closeTime.format(DATE_TIME_FORMAT)}
                                            <div className="lottery-days-left">
                                                {daysLeft} {daysLeftLabel} left
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="rec-data-container">
                                <label htmlFor="rec-lottery-dates">
                                    <b>Lottery Results Available</b>
                                </label>
                                <div className="rec-lottery-dates">
                                    {announcedTime.format(DATE_FORMAT)} (Estimated)
                                </div>
                            </div>
                        </div>
                        <div className="rec-form-item-wrap-full">
                            {!isInFuture && desktopDisabled && (
                                <Button
                                    id="disabled-enter-lottery-button"
                                    isDisabled
                                    size="lg"
                                    onClick={() => {}}
                                    shouldFitContainer
                                    className="bottom-2"
                                    type="button">
                                    Only available on mobile devices
                                </Button>
                            )}
                            {!isInFuture && !desktopDisabled && (
                                <Button
                                    id="enter-lottery-button"
                                    isDisabled={isLoadingButton || isDisabledButton}
                                    isLoading={isLoadingButton}
                                    size="lg"
                                    onClick={() => enterLottery(RES_ID_DELIMITER + this.props.permit.id, lotteryId)}
                                    shouldFitContainer
                                    className="bottom-2"
                                    type="button" >
                                        Register for Open Lottery
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            );
        }).filter((item) => (item));

        return (
            <div className="right-rail-card">
                {futureLotteryTitle && isFutureLottery && (
                    <div className="rec-aside-subheader-gray">
                        <div>{futureLotteryTitle}</div>
                    </div>
                )}
                {lotteriesToRender}
                {lotteriesToRender?.length > 0 && (
                    <>
                        <div className="rec-form-item-wrap-full">
                            <Button
                                appearance="link"
                                shouldFitContainer
                                iconBeforeElement={<Icons.IconHelp />}
                                href='/lottery/how-they-work'>
                                How Does the Lottery Work?
                            </Button>
                        </div>
                    </>
                )}
            </div>
        );
    }
}
